export default {
    name_of_facility: "対象の施設",
    total_sales: "総売上",
    reservation_sales: "予約売上",
    rush_sales: "飛び込み売上",
    number_of_passengers: "利用客数",
    number_of_reservations: "予約件数",
    number_of_dives: "飛び込み件数",
    number_of_cancellations: "キャンセル件数"
}